export const TRANSFORM_ERROR =
  "Une erreur est survenue durant la transformation de la DR.";
